import type {
	PortalOrderDetailResponseDto,
	PortalOrderListResponseDto,
	PortalOrderQueryDto,
	PortalPendingApprovalResponseDto,
	PortalReorderResponseDto,
} from '@supply-mover-2-0/shared';
import { buildQueryString, portalFetch } from '../lib/apiClient';

/**
 * Fetch order history across all assigned clients with optional filters.
 */
export async function getOrders(
	token: string,
	params: PortalOrderQueryDto,
): Promise<PortalOrderListResponseDto> {
	const qs = buildQueryString({
		page: params.page,
		limit: params.limit,
		search: params.search,
		clientId: params.clientId,
		dateFrom: params.dateFrom,
		dateTo: params.dateTo,
	});
	return portalFetch<PortalOrderListResponseDto>(`/orders${qs}`, token);
}

/**
 * Fetch orders pending this user's approval.
 */
export async function getPendingApproval(
	token: string,
	params: PortalOrderQueryDto,
): Promise<PortalPendingApprovalResponseDto> {
	const qs = buildQueryString({
		page: params.page,
		limit: params.limit,
		search: params.search,
		clientId: params.clientId,
	});
	return portalFetch<PortalPendingApprovalResponseDto>(
		`/orders/pending-approval${qs}`,
		token,
	);
}

/**
 * Fetch a single order detail with line items.
 */
export async function getOrder(
	token: string,
	orderId: number,
): Promise<PortalOrderDetailResponseDto> {
	return portalFetch<PortalOrderDetailResponseDto>(`/orders/${orderId}`, token);
}

/**
 * Reorder: add a previous order's items to the cart at today's prices. Lines
 * the storefront cannot add (no price, no longer sold) come back in
 * `skippedItems` (PD-16171).
 */
export async function reorder(
	token: string,
	orderId: number,
): Promise<PortalReorderResponseDto> {
	return portalFetch<PortalReorderResponseDto>(
		`/orders/${orderId}/reorder`,
		token,
		{ method: 'POST' },
	);
}
